// Toggling a line's Subscribe/One-Time checkbox, changing its delivery
// frequency, or upgrading its pack size each kick off a short chain of
// /cart/*.js calls before the drawer reflects the new state. Two of these
// firing at once (e.g. Subscribe & Save on one line while Upgrade Pack is
// still mid-flight on another) race each other's reads/writes of the same
// cart — one can remove or add a line the other still assumes is in its old
// state. A counter (not a boolean) tracks however many are in flight at
// once, since several lines can each have their own control — every
// cart-mutating input in the drawer stays disabled, and Checkout stays
// disabled, until EVERY one of them has finished.
var cartCheckoutBusyCount = 0;
function updateCheckoutBusyUI() {
  var isBusy = cartCheckoutBusyCount > 0;
  var checkoutBtn = document.getElementById("CartDrawer-Checkout");
  if (checkoutBtn) {
    checkoutBtn.disabled = isBusy;
    checkoutBtn.classList.toggle("loading", isBusy);
    var spinner = checkoutBtn.querySelector(".loading__spinner");
    if (spinner) spinner.classList.toggle("hidden", !isBusy);
  }
  document
    .querySelectorAll(
      "cart-drawer-items .togglesubscription, cart-drawer-items .toggleupgradepack, cart-drawer-items .item-frequency"
    )
    .forEach(function (el) {
      el.disabled = isBusy;
    });
  // The Subscribe checkbox's own checked state (and the label text it
  // drives via :checked CSS) flips the instant it's clicked — that's native
  // browser behavior, not something JS can delay — but the actual gift
  // add/remove is still 1-3 seconds behind at that point. Dimming the gift
  // row for that whole window makes it read as "still updating" instead of
  // looking like the label already lied about what's in the cart.
  document
    .querySelectorAll("cart-drawer-items .cart-item__gift-row")
    .forEach(function (el) {
      el.classList.toggle("is-updating", isBusy);
    });
}

// Returns a function that releases this specific lock — guarded so it can
// only ever fire once, whether that's because the real async work finished
// or because the safety timeout below fired first. Without that guard (or
// without the timeout at all) a request that never calls back — dropped
// network response, an unrelated drawer reload replacing this line's DOM
// mid-flight, etc. — would leave every cart control disabled forever, which
// is worse than the race condition this exists to prevent. 15s (rather than
// a single request's usual round trip) because the Upgrade Pack flow chains
// up to four sequential /cart/*.js calls before it's done.
// loadingEl (optional) is the control the user actually interacted with —
// its row (.drawer-subscription-wrapper) gets an "is-active-loading" class
// for the duration of the lock. Every other row's controls are still
// disabled by updateCheckoutBusyUI() above, but only the row carrying this
// class shows a spinner (see cart-drawer.liquid's .is-active-loading-scoped
// rules) — otherwise every line's toggle spins in unison any time any one
// of them is mid-request.
function beginCheckoutBusy(loadingEl) {
  cartCheckoutBusyCount += 1;
  var rowEl = loadingEl && loadingEl.closest(".drawer-subscription-wrapper");
  if (rowEl) rowEl.classList.add("is-active-loading");
  updateCheckoutBusyUI();
  var settled = false;
  var safetyTimer = setTimeout(function () {
    if (settled) return;
    settled = true;
    cartCheckoutBusyCount = Math.max(0, cartCheckoutBusyCount - 1);
    if (rowEl) rowEl.classList.remove("is-active-loading");
    updateCheckoutBusyUI();
  }, 15000);
  return function endCheckoutBusy() {
    if (settled) return;
    settled = true;
    clearTimeout(safetyTimer);
    cartCheckoutBusyCount = Math.max(0, cartCheckoutBusyCount - 1);
    if (rowEl) rowEl.classList.remove("is-active-loading");
    updateCheckoutBusyUI();
  };
}

function reconcileGiftBoxItems(wrapperEl, isSubscribing, onDone) {
  var giftToken = wrapperEl && wrapperEl.getAttribute("data-gift-parent-token");
  var rosterAttr = wrapperEl && wrapperEl.getAttribute("data-gift-roster");

  if (!giftToken || !rosterAttr) {
    if (onDone) onDone();
    return;
  }

  var roster = rosterAttr.split(",").filter(Boolean);
  if (roster.length === 0) {
    if (onDone) onDone();
    return;
  }

  var unlockAllOnetime = wrapperEl.getAttribute("data-gift-unlock-all-onetime") === "true";
  var activeIdsAttr = wrapperEl.getAttribute("data-gift-active-ids") || "";
  var activeIds = activeIdsAttr.split(",").filter(Boolean);

  // Gifts are a Subscribe & Save perk by default. Which gifts count as active
  // while subscribing comes straight from the selected variant's own
  // gift_products metafield (same source used on the product page) — not a
  // computed count. One Time Purchase gets no gifts unless the merchant
  // explicitly opted in via unlockAllOnetime.
  var targetVariantIds;
  if (isSubscribing) {
    targetVariantIds = activeIds;
  } else {
    targetVariantIds = unlockAllOnetime ? roster : [];
  }

  fetch(window.Shopify.routes.root + "cart.js")
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      var currentGiftItems = cart.items.filter(function (item) {
        return (
          item.properties &&
          String(item.properties["_GiftBoxParent"]) === String(giftToken)
        );
      });
      var currentVariantIds = currentGiftItems.map(function (item) {
        return String(item.variant_id);
      });

      var toRemove = currentGiftItems.filter(function (item) {
        return targetVariantIds.indexOf(String(item.variant_id)) === -1;
      });
      var toAdd = targetVariantIds.filter(function (variantId) {
        return currentVariantIds.indexOf(String(variantId)) === -1;
      });

      var chain = Promise.resolve();

      if (toRemove.length > 0) {
        var updates = {};
        toRemove.forEach(function (item) {
          updates[item.key] = 0;
        });
        chain = chain.then(function () {
          return fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: updates }),
          }).then(checkGiftRequestOk("remove", toRemove.map(function (item) {
            return item.variant_id;
          })));
        });
      }

      if (toAdd.length > 0) {
        var addBody = JSON.stringify({
          items: toAdd.map(function (variantId) {
            return {
              id: variantId,
              quantity: 1,
              properties: { _GiftBoxItem: true, _GiftBoxParent: giftToken },
            };
          }),
        });
        chain = chain.then(function () {
          return addGiftsWithRetry(addBody, toAdd);
        });
      }

      return chain;
    })
    .catch(function (e) {
      console.error("reconcileGiftBoxItems: gift add/remove failed", e);
    })
    .finally(function () {
      if (onDone) onDone();
    });
}

// A non-2xx response (e.g. the target gift sold out between page load and
// click, or a request Shopify otherwise rejects) previously went completely
// unnoticed — fetch doesn't reject on its own for 4xx/5xx, so the chain kept
// going, the drawer reloaded showing the gift never actually added/removed,
// and nothing in the console explained why. Named per-call so a failure logs
// which half (remove vs add) and which variant ids were involved.
function checkGiftRequestOk(action, variantIds) {
  return function (response) {
    if (!response.ok) {
      throw new Error(
        "reconcileGiftBoxItems: " + action + " request failed with status " +
          response.status + " for variant(s) " + variantIds.join(",")
      );
    }
    return response;
  };
}

// Retries the gift /cart/add.js once after a short delay before giving up.
// Shopify's cart endpoint can briefly lag behind its own just-completed write
// under rapid successive POSTs to the same cart (e.g. the remove that just
// happened immediately before this add) — a transient failure here otherwise
// permanently drops the gift with no recovery until the customer notices and
// re-toggles Subscribe & Save again themselves.
function addGiftsWithRetry(body, variantIds, isRetry) {
  return fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body,
  })
    .then(checkGiftRequestOk("add", variantIds))
    .catch(function (e) {
      if (isRetry) throw e;
      console.error(
        "reconcileGiftBoxItems: gift add failed, retrying once —",
        e
      );
      return new Promise(function (resolve) {
        setTimeout(resolve, 400);
      }).then(function () {
        return addGiftsWithRetry(body, variantIds, true);
      });
    });
}

// Swaps a cart line to the next larger pack-size variant (the "Upgrade To A
// N Month Supply" toggle). Unlike the Subscribe/One-Time toggle, /cart/change.js
// can't change a line's variant — only its quantity/selling_plan — so this
// removes the current line (and any gift items tied to its _GiftBoxParent
// token) and re-adds the target variant with a fresh gift roster, mirroring
// the same _GiftBoxLineToken/_GiftBoxRoster/_GiftBoxActiveIds shape used at
// normal add-to-cart time (see getGiftBoxRoster/addGiftBoxItemsAfterMainAdd
// in global.js) so reconcileGiftBoxItems and the drawer's own rendering keep
// treating it exactly like any other line.
function upgradeCartPack(wrapperEl, onDone) {
  var currentKey = wrapperEl.getAttribute("data-current-key");
  var nextVariantId = wrapperEl.getAttribute("data-next-variant-id");
  var nextRoster = (wrapperEl.getAttribute("data-next-gift-roster") || "")
    .split(",")
    .filter(Boolean);
  var unlockAllOnetime = wrapperEl.getAttribute("data-gift-unlock-all-onetime") === "true";
  var nextPlans = [];
  try {
    nextPlans = JSON.parse(wrapperEl.getAttribute("data-next-selling-plans") || "[]");
  } catch (e) {
    nextPlans = [];
  }

  var subWrapper = wrapperEl.closest(".drawer-subscription-wrapper");
  var isSubscribing = !!(
    subWrapper && subWrapper.querySelector(".togglesubscription:checked")
  );
  var currentFrequencyDigits = "";
  if (subWrapper) {
    var selectedOption = subWrapper.querySelector(".item-frequency option:checked");
    if (selectedOption) {
      currentFrequencyDigits = selectedOption.getAttribute("data-frequency") || "";
    }
  }

  var newToken =
    nextVariantId + "-" + Date.now() + "-" + Math.random().toString(36).slice(2, 8);

  // Guarantees onDone (which reloads the drawer, actually resyncing it —
  // beginCheckoutBusy's own safety timeout above only resets the busy
  // counter/UI, it doesn't reload) fires exactly once. Kept in lockstep with
  // that same 15s window so the two can't disagree about when "stuck" means
  // stuck — a shorter timeout here would let this fire, reload the drawer,
  // and finish while the outer lock is still artificially held for a few
  // more seconds; a longer one would let the outer lock free up every other
  // toggle in the drawer before this one has actually let go of its own.
  var settled = false;
  var safetyTimer = setTimeout(function () {
    if (settled) return;
    settled = true;
    console.error("upgradeCartPack: timed out waiting for the cart to update");
    if (onDone) onDone();
  }, 15000);
  function finish() {
    if (settled) return;
    settled = true;
    clearTimeout(safetyTimer);
    if (onDone) onDone();
  }

  // A non-2xx response (e.g. the target variant sold out between page load
  // and click) still resolves the fetch promise rather than rejecting it —
  // without this check the chain would silently keep going and add gift
  // items for a main item that was never actually added.
  function checkOk(response) {
    if (!response.ok) {
      throw new Error("Cart request failed with status " + response.status);
    }
    return response;
  }

  // Quantity and the current gift items' cart keys come straight off the
  // wrapper (rendered server-side by cart-drawer.liquid the same way the
  // visible gift row is), so this skips the GET /cart.js round trip that
  // would otherwise exist purely to look the same two things up.
  var qty = parseInt(wrapperEl.getAttribute("data-current-quantity"), 10) || 1;
  var currentGiftKeys = (wrapperEl.getAttribute("data-current-gift-keys") || "")
    .split(",")
    .filter(Boolean);

  var updates = {};
  updates[currentKey] = 0;
  currentGiftKeys.forEach(function (key) {
    updates[key] = 0;
  });

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ updates: updates }),
  })
    .then(checkOk)
    .then(function () {
      var newItem = {
        id: nextVariantId,
        quantity: qty,
        properties: {
          _GiftBoxLineToken: newToken,
          _GiftBoxRoster: nextRoster.join(","),
          _GiftBoxActiveIds: nextRoster.join(","),
          _GiftBoxUnlockAllOnetime: unlockAllOnetime ? "true" : "false",
        },
      };

      if (isSubscribing && nextPlans.length > 0) {
        var matched = nextPlans.filter(function (plan) {
          return (
            String(plan.name).replace(/[^0-9.]/g, "") === String(currentFrequencyDigits)
          );
        })[0];
        newItem.selling_plan = (matched || nextPlans[0]).id;
      }

      // The new main item and its gift items go in ONE /cart/add.js call
      // (Shopify's items array happily takes several distinct lines at once)
      // instead of two sequential requests — one less round trip that could
      // stall, and one less place for the flow to get stuck between steps.
      var activeGiftIds = isSubscribing || unlockAllOnetime ? nextRoster : [];
      var giftItems = activeGiftIds.map(function (variantId) {
        return {
          id: variantId,
          quantity: 1,
          properties: { _GiftBoxItem: true, _GiftBoxParent: newToken },
        };
      });

      return fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [newItem].concat(giftItems) }),
      }).then(checkOk);
    })
    .catch(function (e) {
      console.error(e);
    })
    .finally(function () {
      finish();
    });
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
    document.dispatchEvent(new Event("initCartFunctions"));
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ]; 
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

let clearBtn = document.querySelector("#remove-discount-code");
let applyBtn = document.querySelector("#apply-discount-button");
let discountCodeError = document.querySelector("#discount-code-error");
let discountCodeWrapper = document.querySelector(
  "#applied-discount-code .applied-discount-code-wrapper"
);
let discountCodeValue = document.querySelector(
  "#applied-discount-code .applied-discount-code-value"
);
let discountCodeInput = document.querySelector("#discount-coupon-text");
let totalCartSelector = document.querySelector(".cart__subtotal .money"); // no longer used for discount localStorage
let authorization_token;

let checkoutContainer = document.createElement("div");

initCartFunctions();

document.addEventListener("initCartFunctions", () => {
  initCartFunctions();
});

function initCartFunctions() {
  console.log("ddddddd");
  let clearBtn = document.querySelector("#remove-discount-code");
  let applyBtn = document.querySelector("#apply-discount-button");
  let discountCodeError = document.querySelector("#discount-code-error");
  let discountCodeWrapper = document.querySelector(
    "#applied-discount-code .applied-discount-code-wrapper"
  );
  let discountCodeValue = document.querySelector(
    "#applied-discount-code .applied-discount-code-value"
  );
  let discountCodeInput = document.querySelector("#discount-coupon-text");
  let totalCartSelector = document.querySelector(".cart__subtotal .money"); // no longer used for discount localStorage
  let authorization_token;

  let checkoutContainer = document.createElement("div");
  $(".subscription-info svg")
    .unbind()
    .click(function (event) {
      // .subscription-info sits in the same corner as the Subscribe
      // checkbox's own full-row <label> (clicking anywhere inside a
      // <label> toggles its checkbox natively) — stopPropagation keeps
      // this click from ever reaching that label and flipping the
      // subscription instead of just opening the info popup.
      event.stopPropagation();
      event.preventDefault();
      $(this).next(".subscription-info-content").toggle();
    });

  $("cart-drawer-items .item-frequency").each(function () {
    $(this)
      .find("option")
      .each(function () {
        var str = $(this).attr("data-frequency");
        $(this).attr("data-frequency", str.replace(/[^0-9.]/g, ""));
      });
  });

  $(".drawer-subscription-wrapper .item-frequency")
    .unbind()
    .change(function () {
      var cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      var key = $(this)
        .parents(".drawer-subscription-wrapper")
        .find(".togglesubscription")
        .attr("id");

      var selling_plan = $(this)
        .parents(".drawer-subscription-wrapper")
        .find(".item-frequency")
        .val();
      var qty = $(this)
        .parents(".cart-item__quantity")
        .find(".quantity__input")
        .val();

      var endCheckoutBusy = beginCheckoutBusy(this);
      $.ajax({
        method: "POST",
        url: "/cart/change.js",
        data: {
          id: key,
          quantity: qty,
          selling_plan: selling_plan,
          sections: cart.getSectionsToRender().map((section) => section.id),
        },
        dataType: "json",
        success: function (data) {
          reloadDrawer().then(endCheckoutBusy);
        },
        error: function () {
          reloadDrawer().then(endCheckoutBusy);
        },
      });
    });

  $(".subscription-wrapper input")
    .unbind()
    .change(function () {
      var cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      var subscriptionWrapperEl = $(this).closest(".subscription-wrapper")[0];
      var isSubscribing = $(this).is(":checked");
      var endCheckoutBusy = beginCheckoutBusy(this);
      var $toggle = $(this);
      // Stays disabled for the full round trip — the /cart/change.js call AND
      // the gift reconcile that follows it — so a second click can't fire
      // while gift items are still being added/removed for the first one.
      // reloadDrawer() (success or error) always replaces this checkbox with
      // a fresh, enabled one, so nothing needs to explicitly re-enable it.
      $toggle.prop("disabled", true);
      if ($(this).is(":checked")) {
        $(this)
          .parents(".drawer-subscription-wrapper")
          .find(".drawer-dropdown")
          .show();
        var key = $(this).attr("id");
        var selling_plan = $(this)
          .parents(".drawer-subscription-wrapper")
          .find(".item-frequency")
          .val();
        var qty = $(this)
          .parents(".cart-item__quantity")
          .find(".quantity__input")
          .val();

        if (
          $(this)
            .parents(".drawer-subscription-wrapper")
            .find(".item-frequency")
            .find('option[data-frequency="4"]').length > 0
        ) {
          $(this)
            .parents(".drawer-subscription-wrapper")
            .find(".item-frequency")
            .val(
              $(this)
                .parents(".drawer-subscription-wrapper")
                .find(".item-frequency")
                .find('option[data-frequency="4"]')
                .attr("value")
            );
          selling_plan = $(this)
            .parents(".drawer-subscription-wrapper")
            .find(".item-frequency")
            .find('option[data-frequency="4"]')
            .attr("value");
        }
        $.ajax({
          method: "POST",
          url: "/cart/change.js",
          data: {
            id: key,
            quantity: qty,
            selling_plan: selling_plan,
            sections: cart.getSectionsToRender().map((section) => section.id),
          },
          dataType: "json",
          success: function (data) {
            reconcileGiftBoxItems(subscriptionWrapperEl, isSubscribing, function () {
              reloadDrawer().then(endCheckoutBusy);
            });
          },
          error: function () {
            reloadDrawer().then(endCheckoutBusy);
          },
        });
      }

      if (!$(this).is(":checked")) {
        $(this)
          .parents(".drawer-subscription-wrapper")
          .find(".drawer-dropdown")
          .hide();
        var key = $(this).attr("id");
        var selling_plan = $(this)
          .parents(".drawer-subscription-wrapper")
          .find(".item-frequency")
          .val();
        var qty = $(this)
          .parents(".cart-item__quantity")
          .find(".quantity__input")
          .val();
        $.ajax({
          method: "POST",
          url: "/cart/change.js",
          data: {
            id: key,
            quantity: qty,
            selling_plan: "",
            sections: cart.getSectionsToRender().map((section) => section.id),
          },
          dataType: "json",
          success: function (data) {
            reconcileGiftBoxItems(subscriptionWrapperEl, isSubscribing, function () {
              reloadDrawer().then(endCheckoutBusy);
            });
          },
          error: function () {
            reloadDrawer().then(endCheckoutBusy);
          },
        });
      }
    });

  // Starts every rebind unchecked, defensively — nothing in the server
  // render sets `checked` on this input, but if it were ever left checked
  // (e.g. a rebind landing between two rapid Subscribe & Save toggles), the
  // very next real click would visually UNCHECK it and — before this fix —
  // silently do nothing at all: no request, no error, exactly "upgrade
  // doesn't work" with nothing in the console to explain why.
  $(".upgrade-pack-wrapper .toggleupgradepack").prop("checked", false);
  $(".upgrade-pack-wrapper .toggleupgradepack")
    .unbind()
    .change(function () {
      // This toggle only ever means "trigger the upgrade" — there's no
      // downgrade path back through it, so a user-initiated change event
      // should always act, regardless of whether the click happened to
      // leave the checkbox checked or unchecked. Forcing it checked here
      // (instead of bailing out on `!checked`) removes that whole class of
      // "click did nothing" bug rather than depending on the checkbox
      // always starting from the expected state.
      $(this).prop("checked", true);
      var wrapperEl = this.closest(".upgrade-pack-wrapper");
      var endCheckoutBusy = beginCheckoutBusy(this);
      $(this).prop("disabled", true);
      upgradeCartPack(wrapperEl, function () {
        reloadDrawer().then(endCheckoutBusy);
      });
    });

  var swiper = new Swiper(".complementory-products-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
    },
    navigation: {
      nextEl: ".complementory-next",
      prevEl: ".complementory-prev",
    },
  });

  $(".discount-heading")
    .unbind()
    .click(function () {
      var $this = $(this);
      $this.next().toggleClass("active");

      setTimeout(function () {
        $this.next().removeClass("active");
      }, 20000);
    });
  $(".complementory-products-atc")
    .unbind()
    .click(function () {
      // Wasn't gated by beginCheckoutBusy/endCheckoutBusy at all before —
      // its own reloadDrawer() could fire concurrently with a Subscribe/
      // Upgrade toggle's still-in-flight one, and whichever fetch resolved
      // last would win the replaceWith, silently discarding the other's
      // (possibly more current) gift/line state. Same lock as every other
      // cart-mutating control in the drawer now applies here too.
      var endCheckoutBusy = beginCheckoutBusy(this);
      var varid = $(this).data("varid");
      $(this).prop("disabled", true);
      $(this).find(".loading__spinner").removeClass("hidden");
      $(this).find(".atc-text").css("opacity", "0");
      var this2 = this;
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: varid, quantity: 1 }),
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          $(this2).find(".loading__spinner").addClass("hidden");
          $(this2).find(".atc-text").css("opacity", "1");
          reloadDrawer().then(endCheckoutBusy);
        })
        .catch((error) => {
          endCheckoutBusy();
          console.error("Error:", error);
        });
    });

  $(".bundle-close-button").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var updates = {};
    var bundleadded = false;
    $(this).find(".close-btn-icon").hide();
    $(this).find(".loading__spinner ").removeClass("hidden");
    $(".bundle-cart-item .bundle-items").each(function () {
      updates[$(this).data("itemkey")] = 0;
    });
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: updates,
      }),
    })
      .then((response) => response.json())
      .then((newCart) => {
        var ID = $(".main-progress-bar-container").data("freeitem");
        var threshhold = $(".secondstagecprice").data("price");
        console.log(newCart.items_subtotal_price);
        console.log(threshhold);
        for (var i = 0; i < newCart.items.length; i++) {
          var properties = newCart.items[i].properties;
          if (newCart.items[i].variant_id == ID && !properties["_GiftBoxItem"]) {
            bundleadded = true;
            updates[newCart.items[i].key] = 0;
          }
        }

        if (bundleadded == true) {
          fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              updates: updates,
            }),
          })
            .then((response) => response.json())
            .then((newCart) => {
              reloadDrawer();
            })
            .catch(console.error);
        } else {
          reloadDrawer();
        }
      })
      .catch(console.error);
  });

  document.body.appendChild(checkoutContainer);

  if (applyBtn)
    applyBtn.addEventListener("click", function (e) {
      e.preventDefault();
      applyDiscount(discountCodeInput.value);
    });
  if (clearBtn)
    clearBtn.addEventListener("click", function (e) {
      console.log("buttn clicked clear");
      e.preventDefault();
      clearDiscount();
    });

  // NEW clearDiscount using cart/update.js (no localStorage)
  function clearDiscount() {
    if (clearBtn) {
      clearBtn.innerHTML = "Removing..";
    }

    $(".discount-announcement-slider.discounted-wrapper").hide();
    $(".discount-announcement-slider.non-discounted-wrapper").show();

    const formData = new FormData();
    formData.append("discount", ""); // empty string = remove all discounts

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        reloadDrawer();
        // var applycode = new CustomEvent("applyDiscountCode", {
        //     detail: { code: code },
        //   });
        //   document.dispatchEvent(applycode);
        $("main-product-form").load(location.href + " main-product-form");
      })
      .catch((error) => {
        console.error("Clear discount error:", error);
      })
      .finally(() => {
        if (clearBtn) {
          clearBtn.innerHTML = "Clear";
        }
      });
  }

  // NEW applyDiscount using cart/update.js (no payments/wallets, no localStorage)
  function applyDiscount(code) {
    code = (code || "").trim();
    if (!code) return;

    $(".discount-announcement-slider.discounted-wrapper").show();
    $(".discount-announcement-slider.non-discounted-wrapper").hide();

    if (applyBtn) {
      applyBtn.innerHTML = "Applying.. <div class='loader'></div>";
      applyBtn.style.pointerEvents = "none";
    }

    const formData = new FormData();
    formData.append("discount", code);

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) =>
        response.json().then((cart) => ({ cart, ok: response.ok }))
      )
      .then(({ cart, ok }) => {
        const hasDiscount =
          (cart.cart_level_discount_applications &&
            cart.cart_level_discount_applications.length > 0) ||
          (typeof cart.total_discount === "number" &&
            cart.total_discount > 0);

        if (!ok || !hasDiscount) {
          throw new Error("INVALID_DISCOUNT");
        }

        if (discountCodeWrapper) {
          discountCodeWrapper.style.display = "inline";
        }
        if (discountCodeError) {
          discountCodeError.innerHTML = "";
        }

        if (discountCodeValue) {
          let title = code;
          if (
            cart.cart_level_discount_applications &&
            cart.cart_level_discount_applications.length > 0
          ) {
            title =
              cart.cart_level_discount_applications[0].title || code;
          }

          let amountText = "";
          if (
            typeof cart.total_discount === "number" &&
            cart.total_discount > 0
          ) {
            const amount = (cart.total_discount / 100).toFixed(2);
            amountText =
              " (" + Shopify.currency.active + " " + amount + ")";
          }

          discountCodeValue.innerHTML = title + amountText;
        }

        setTimeout(function () {
          reloadDrawer();

          var applycode = new CustomEvent("applyDiscountCode", {
            detail: { code: code },
          });
          document.dispatchEvent(applycode);
           //$("main-product-form").load(location.href + " main-product-form");
        }, 500);

        $(".discount-boxes-wrapper").removeClass("dsicount-eeor");
        $("#discount-code-error").hide();
      })
      .catch((error) => {
        if (discountCodeValue) {
          discountCodeValue.innerHTML = "";
        }

        if (discountCodeError) {
          discountCodeError.innerHTML = "Please Enter Valid Coupon Code.";
        }

        $(".discount-boxes-wrapper").addClass("dsicount-eeor");
        $("#discount-code-error").show();
        $(".discount-announcement-slider.discounted-wrapper").hide();
        $(".discount-announcement-slider.non-discounted-wrapper").show();
      })
      .finally(() => {
        if (applyBtn) {
          applyBtn.innerHTML = "Apply";
          applyBtn.style.pointerEvents = "auto";
        }
      });
  }

  $(".cart__checkout-button")
    .unbind()
    .click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).find(".loading__spinner").removeClass("hidden");
      $(this).find("span").hide();
      var this2 = this;
      // The capture listener below has normally already synced the gift
      // before replaying this click; only sync here if it somehow didn't.
      var giftReady = freeGiftJustSynced
        ? Promise.resolve()
        : freeGiftSyncPromise || syncFreeGiftLine();
      freeGiftJustSynced = false;
      giftReady.then(function () {
        $(this2).find(".loading__spinner").addClass("hidden");
        $(this2).find("span").show();
        window.location.href = "/checkout";
      });
    });
}

// The free gift is only shown in the drawer (snippets/free-product.liquid) —
// it isn't a real cart line until the shopper heads to checkout, at which
// point this removes any stale gift line and adds exactly one if the
// threshold is met. Safe to call more than once.
var freeGiftSyncPromise = null;
function syncFreeGiftLine() {
  // OCU can call callbackBeforeRedirect (and so this) twice at once. Two
  // overlapping syncs each removed the gift line by key — and Shopify, given
  // a key that's already gone, falls back to the FIRST line of that variant,
  // which deleted the gift-box Magnesium — then both re-added the gift, so
  // checkout showed one "Magnesium ×2" row. A second caller now just joins
  // the sync already in flight.
  if (freeGiftSyncPromise) return freeGiftSyncPromise;
  var ID = $(".main-progress-bar-container").data("freeitem");
  var threshhold = $(".secondstagecprice").data("price");
  // Waits out repairCartAfterCheckout's cleanup if a Checkout click lands
  // while it's still running — otherwise its late remove (same line key)
  // could delete the gift line this is about to add.
  freeGiftSyncPromise = (freeGiftRepairPromise || Promise.resolve())
    .then(() => fetch("/cart.js"))
    .then((response) => response.json())
    .then((cartdata) => {
      var updates = {};
      var hasGift = false;
      var giftLines = [];
      for (var i = 0; i < cartdata.items.length; i++) {
        // The same Magnesium variant can also be a product's gift-box pick
        // (_GiftBoxItem) — that line belongs to its parent, not this reward.
        if (
          cartdata.items[i].variant_id == ID &&
          !cartdata.items[i].properties["_GiftBoxItem"]
        ) {
          hasGift = true;
          giftLines.push(cartdata.items[i]);
          updates[cartdata.items[i].key] = 0;
        }
      }
      var qualifies = ID && cartdata.items_subtotal_price >= threshhold;
      // Already exactly right (e.g. the capture listener synced moments ago
      // and OCU's redirect hook asks again) — leave the cart untouched.
      if (
        qualifies &&
        giftLines.length === 1 &&
        giftLines[0].quantity === 1 &&
        giftLines[0].properties["_freeGift"] &&
        giftLines[0].properties["Reward"]
      ) {
        return;
      }
      var removeGift = hasGift
        ? fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: updates }),
          })
        : Promise.resolve();
      return removeGift.then(() => {
        if (!qualifies) return;
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [
              {
                id: ID,
                quantity: 1,
                // The visible "Reward" property isn't just a label: Shopify
                // checkout merges lines of the same variant whose properties
                // differ only in hidden (_-prefixed) keys, which folded this
                // line into the gift-box Magnesium line as one qty-2 row.
                properties: { _freeGift: true, Reward: "Free gift" },
              },
            ],
          }),
        });
      });
    })
    .catch(console.error)
    .finally(() => {
      freeGiftSyncPromise = null;
    });
  return freeGiftSyncPromise;
}

// One Click Upsell hijacks the Checkout click before the jQuery handler above
// ever runs. When it has an offer it shows its popup; when it doesn't (e.g. a
// subscription cart) it sends the shopper straight to /checkout — in both
// cases the gift was never added, or was still mid-request when the page
// left. So this capture listener on window (ahead of the app's own) holds the
// click until the gift line is in the cart, then replays it untouched for the
// app / jQuery handler to carry on exactly as before.
var freeGiftReplayingClick = false;
var freeGiftJustSynced = false;
window.addEventListener(
  "click",
  function (e) {
    var btn = e.target.closest && e.target.closest(".cart__checkout-button");
    if (!btn) return;
    if (freeGiftReplayingClick) {
      freeGiftReplayingClick = false;
      freeGiftJustSynced = true;
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    freeGiftJustSynced = false;
    hookFreeGiftIntoOcuRedirect();
    if (freeGiftSyncPromise) return; // double-click while already syncing
    $(btn).find(".loading__spinner").removeClass("hidden");
    $(btn).find("span").hide();
    syncFreeGiftLine().then(function () {
      $(btn).find(".loading__spinner").addClass("hidden");
      $(btn).find("span").show();
      freeGiftReplayingClick = true;
      btn.click();
      freeGiftReplayingClick = false;
    });
  },
  true
);

// Accepting an OCU offer (e.g. Upgrade to 3 Bottles) changes the cart AFTER
// the sync above ran, so a cart that only crosses the threshold through the
// upgrade went to checkout without its gift. OCU awaits
// OCUApi.callbackBeforeRedirect (its documented hook, default a no-op
// resolving to {}) right before it sends the shopper to checkout, so the gift
// is re-synced there against the upgraded cart.
function hookFreeGiftIntoOcuRedirect() {
  var api = window.OCUApi;
  if (!api || api.freeGiftRedirectHooked) return;
  var originalCallback = api.callbackBeforeRedirect;
  api.callbackBeforeRedirect = function () {
    var self = this;
    var args = arguments;
    return syncFreeGiftLine()
      .then(function () {
        return originalCallback ? originalCallback.apply(self, args) : {};
      })
      .then(function (result) {
        return result || {};
      });
  };
  api.freeGiftRedirectHooked = true;
}

// A _freeGift line should only ever exist on the way to checkout, so finding
// one on page load means the shopper came back from checkout. The drawer
// never renders that line (it shows its own gift row from
// free-product.liquid instead), so removing it is done silently — no busy
// spinner, no drawer reload. Only if a gift-box item actually went missing
// (older carts where checkout merged the two Magnesium lines into one qty-2
// line, before the visible "Reward" property kept them apart) does this
// re-add it — using the same roster rules as reconcileGiftBoxItems() — and
// reload the drawer so the row shows up.
var freeGiftRepairPromise = null;
function repairCartAfterCheckout() {
  freeGiftRepairPromise = fetch(window.Shopify.routes.root + "cart.js")
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      var updates = {};
      var hasLeftover = false;
      var giftBoxNeedsFix = false;
      cart.items.forEach(function (item) {
        var props = item.properties || {};
        if (props["_freeGift"] && !props["_GiftBoxItem"]) {
          updates[item.key] = 0;
          hasLeftover = true;
        } else if (props["_GiftBoxItem"] && item.quantity > 1) {
          updates[item.key] = 1;
          giftBoxNeedsFix = true;
        }
      });
      if (!hasLeftover && !giftBoxNeedsFix) return;

      var toAdd = [];
      cart.items.forEach(function (parent) {
        var props = parent.properties || {};
        var token = props["_GiftBoxLineToken"];
        if (!token) return;
        var roster = String(props["_GiftBoxRoster"] || "").split(",").filter(Boolean);
        var activeIds = String(props["_GiftBoxActiveIds"] || "").split(",").filter(Boolean);
        var targetVariantIds = parent.selling_plan_allocation
          ? activeIds
          : props["_GiftBoxUnlockAllOnetime"] === "true"
          ? roster
          : [];
        var presentVariantIds = cart.items
          .filter(function (item) {
            return (
              item.properties &&
              String(item.properties["_GiftBoxParent"]) === String(token) &&
              updates[item.key] !== 0
            );
          })
          .map(function (item) {
            return String(item.variant_id);
          });
        targetVariantIds.forEach(function (variantId) {
          if (presentVariantIds.indexOf(String(variantId)) !== -1) return;
          toAdd.push({
            id: variantId,
            quantity: 1,
            properties: { _GiftBoxItem: true, _GiftBoxParent: token },
          });
        });
      });

      var removeLeftover = fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates }),
      });

      if (!giftBoxNeedsFix && toAdd.length === 0) {
        return removeLeftover
          .then(reloadCartIconBubble)
          .catch(console.error);
      }

      // No beginCheckoutBusy() here: its spinner/dimming is what the shopper
      // saw as "loading" on opening the drawer. A Checkout click mid-repair
      // is already covered — syncFreeGiftLine() waits on
      // freeGiftRepairPromise — and the drawer just quietly re-renders with
      // the restored row once this finishes.
      return removeLeftover
        .then(function () {
          if (toAdd.length === 0) return;
          return addGiftsWithRetry(
            JSON.stringify({ items: toAdd }),
            toAdd.map(function (item) {
              return item.id;
            })
          );
        })
        .catch(function (e) {
          console.error("repairCartAfterCheckout failed", e);
        })
        .then(function () {
          return reloadDrawer();
        });
    })
    .catch(console.error)
    .finally(function () {
      freeGiftRepairPromise = null;
    });
}
// Runs the moment this (deferred) script executes rather than on pageshow,
// which only fires after every image has loaded — late enough that the
// shopper had usually already opened the drawer and watched the repair
// happen. pageshow is still needed for the Back button restoring the page
// from the back/forward cache, where scripts don't re-run.
repairCartAfterCheckout();
window.addEventListener("pageshow", function (e) {
  if (e.persisted) repairCartAfterCheckout();
});

class BundleItems extends HTMLElement {
  constructor() {
    super();
  }
}
customElements.define("bundle-items", BundleItems);

let searchParams = new URLSearchParams(window.location.search);

if (searchParams.has("discount")) {
  if (searchParams.has("cart_items")) {
    var cart_items = searchParams.get("cart_items");
    var aritems = cart_items.split("___");
    var additems = [];
    for (let i = 0; i < aritems.length; i++) {
      var aritem = aritems[i].split("_");
      var job = {};
      job["id"] = aritem[0];
      job["quantity"] = aritem[1];
      if (aritem[2]) {
        job["selling_plan"] = aritem[2];
      }
      job["properties"] = {
        _disabled_item: true,
      };
      additems.push(job);
    }
    var cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    $.ajax({
      type: "GET",
      url: "/cart/clear.js",
      dataType: "json",
      success: function (cartdata) {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData();
        if (cart) {
          formData.append(
            "sections",
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }

        for (let index = 0; index < additems.length; index++) {
          formData.append("items[" + index + "][id]", additems[index]["id"]);
          formData.append(
            "items[" + index + "][quantity]",
            additems[index]["quantity"]
          );
          formData.append(
            "items[" + index + "][properties][_disabled_item]",
            true
          );
          if (additems[index]["selling_plan"]) {
            formData.append(
              "items[" + index + "][selling_plan]",
              additems[index]["selling_plan"]
            );
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            cart.renderContents(response);
            cart.open();
            $("cart-drawer").removeClass("is-empty");
            document.dispatchEvent(new Event("initCartFunctions"));
            applyUrlDiscount();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {});
      },
    });
  } else {
    applyUrlDiscount();
  }
}

// NEW applyUrlDiscount using cart/update.js (no localStorage)
function applyUrlDiscount() {
  var code = searchParams.get("discount");
  if (!code) return;

  if (discountCodeInput) {
    discountCodeInput.value = code;
  }

  const formData = new FormData();
  formData.append("discount", code);

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    body: formData,
    headers: {
      Accept: "application/json",
    },
  })
    .then((response) => response.json())
    .then((cart) => {
      $(".first-order").show();
      setTimeout(function () {
        reloadDrawer();
        var applycode = new CustomEvent("applyDiscountCode", {
          detail: { code: code },
        });
        document.dispatchEvent(applycode);
      }, 1000);
    })
    .catch((error) => {
      console.error("Discount from URL error:", error);
    });
}

$(".discount-text")
  .unbind()
  .click(function () {
    $(this).parent(".discount-boxes-wrapper").removeClass("dsicount-eeor");
    $("#discount-code-error").hide();
  });

// Returns the promise for the main content swap (not the secondary cart-icon
// bubble / discount-announcement fetches below, which are unrelated to
// visible cart-line content) so callers that gate a "busy" UI state — e.g.
// re-enabling the Subscribe checkbox and un-dimming the gift row — can wait
// for it via reloadDrawer().then(...) instead of firing that release the
// instant this function is merely CALLED. It always resolves, success or
// failure, since the catch below only logs and re-dispatches rather than
// rethrowing — a caller doesn't need its own .catch.
function reloadDrawer() {
  var mainSwap = fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const selectors = [
        "cart-drawer-items",
        ".cart-drawer__footer",
        ".drawer-discount-wrapper",
      ];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
      document.dispatchEvent(new Event("initCartFunctions"));
    })
    .catch((e) => {
      console.error(e);
      document.dispatchEvent(new Event("initCartFunctions"));
    });
  reloadCartIconBubble();
  reloadDiscountAnnouncement();
  return mainSwap;
}
function reloadCartIconBubble() {
  fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
    .then((response) => response.text())
    .then((responseText) => {
      const cartIconBubble = document.getElementById("cart-icon-bubble");
      if (!cartIconBubble) return;
      const source = new DOMParser()
        .parseFromString(responseText, "text/html")
        .querySelector(".shopify-section");
      if (source) cartIconBubble.innerHTML = source.innerHTML;
    })
    .catch((e) => console.error(e));
}
function reloadDiscountAnnouncement() {
  const announcementEl = document.querySelector('discount-announcement');
  if (!announcementEl) return;
  const sectionId = announcementEl.dataset.sectionid;

  fetch(`/?section_id=${sectionId}`)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const newSection = doc.querySelector('discount-announcement');
      const oldSection = document.querySelector('discount-announcement');

      if (newSection && oldSection) {
        oldSection.replaceWith(newSection);
      }
      window.dispatchEvent(new Event('resize'));
    });
}